<div class="error-container">
  <img
    [src]="configuration.route"
    [alt]="configuration.title"
    [ngStyle]="{ width: configuration.width }"
  />
  <h2>{{ configuration.title }}</h2>
  <p class="error-content" [innerHTML]="configuration.content"></p>
  <ul *ngIf="configuration.bullets">
    <li *ngFor="let bullet of configuration.bullets" [innerHTML]="bullet"></li>
  </ul>

  <div class="container box-link" *ngIf="configuration.link">
    <a class="btn btn-degraded blue link" (click)="onSubmit()">{{
      configuration.link.text
    }}</a>
  </div>

  <div class="container box-link" *ngIf="configuration.redirect">
    <a
      class="btn btn-degraded blue link redirect"
      (click)="
        redirect(configuration.redirect.url, configuration.redirect.queryParams)
      "
      >{{ configuration.redirect.text }}</a
    >
  </div>

  <div class="container mb-box-link" *ngIf="configuration.mobile">
    <a class="btn btn-degraded blue link" [href]="configuration.mobile.url">{{
      configuration.mobile.text
    }}</a>
  </div>
</div>
